module.exports = __webpack_public_path__ + "media/images/river/exclusive-fa3fc2c8996e7c34291ef61888950e90.jpg";